import React, {useEffect, useState} from "react";
import {Button, Input, message, Pagination, Space, Spin, Table,} from "antd";
import {ApiClient, ApiClientType} from "../../clients/api-client";
import {GetUserId} from "../../utils/getUserId";
import { useNavigate } from "react-router-dom";

const ApprovalsPage = () => {
    const navigate = useNavigate();
    const userId = GetUserId();
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [loading, setLoading] = useState(false);
    const [remarks, setRemarks] = useState({}); // key: approvalStepId
    const [requestDetails, setRequestDetails] = useState({}); // key: approvalRequestId
    const [inspectionDetails, setInspectionDetails] = useState({}); // key: inspectionId
    console.log(inspectionDetails)
    const fetchInspectionDetail = async (entityId) => {
        if (inspectionDetails[entityId]) return;
        try {
            const res = await ApiClient(
                ApiClientType.get,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/incoming-quality-inspections/${entityId}`
            );
            setInspectionDetails((prev) => ({
                ...prev,
                [entityId]: res.data || {},
            }));
        } catch (err) {
            console.warn("Failed to fetch inspection for entityId:", entityId, err);
        }
    };

    const fetchApprovalRequest = async (id) => {
        if (requestDetails[id]) return;

        try {
            const res = await ApiClient(
                ApiClientType.get,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/approval-requests/${id}`
            );
            const reqData = res.data || {};
            console.log(reqData)
            setRequestDetails((prev) => ({
                ...prev,
                [id]: reqData,
            }));

            if (reqData?.entityType === "inspection" && reqData.entityId) {
                await fetchInspectionDetail(reqData?.entityId);
            }
        } catch (err) {
            console.warn("Failed to fetch approval request for ID:", id, err);
        }
    };

    const fetchApprovals = async (page = 1, limit = 10) => {
        setLoading(true);
        try {
            const offset = (page - 1) * limit;
            const response = await ApiClient(
                ApiClientType.post,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/approval-steps/search`,
                {
                    filter: {
                        association: "and",
                        conditions: [
                            { field: "approver_ids", operation: "in", value: [userId] },
                            { field: "status", operation: "eq", value: "pending" },
                        ],
                    },
                    page: {
                        limit,
                        offset,
                    },
                    sort: {
                        field: "created_at",
                        direction: "desc",
                    },
                }
            );

            const steps = response.data || [];

            await Promise.all(
                steps.map((step) => fetchApprovalRequest(step.approvalRequestId))
            );

            setData(steps);
            setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: limit,
                total: response.totalCount || 0,
            }));
        } catch (e) {
            console.error("Failed to fetch approvals", e);
            message.error("Failed to fetch approval requests");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchApprovals(pagination.current, pagination.pageSize);
    }, []);

    const handleDecision = async (stepId, decision) => {
        const remark = remarks[stepId] || "";
        try {
            await ApiClient(
                ApiClientType.post,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/approval-requests/decision`,
                {
                    status: decision,
                    remarks: remark,
                    stepId: stepId,
                },
            );
            message.success(`Successfully ${decision}ed step`);
            fetchApprovals(pagination.current, pagination.pageSize);
        } catch (err) {
            console.error(`Failed to ${decision} step`, err);
            message.error(`Failed to ${decision} step`);
        }
    };

    const columns = [
        {
            title: "From",
            key: "inspectionInfo",
            render: (_, record) => {
                const request = requestDetails[record.approvalRequestId];
                if (!request || request?.entityType !== "inspection") return "-";

                const entityId = request.entityId;
                const insp = inspectionDetails[entityId];
                if (!insp) return "Loading...";

                const key = insp?.key || entityId;
                const verdict = insp?.verdict || insp?.status || "-";

                return (
                    <div>
                        <div>
                            <a 
                                href={`/application/inspections/${key}/details`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: '#1890ff' }}
                            >
                                <strong>Inspection #{key}</strong>
                            </a>
                        </div>
                        <div style={{ fontSize: "12px", color: "#888" }}>
                            Verdict: {verdict}
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Remarks",
            key: "remarks",
            render: (_, record) => (
                <Input
                    placeholder="Add remarks"
                    value={remarks[record.id] || ""}
                    onChange={(e) =>
                        setRemarks({ ...remarks, [record.id]: e.target.value })
                    }
                />
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleDecision(record.id, "approved")}
                    >
                        Accept
                    </Button>
                    <Button danger onClick={() => handleDecision(record.id, "rejected")}>
                        Reject
                    </Button>
                </Space>
            ),
        },
    ];


    return (
        <div style={{ padding: "32px" }}>
            <h2 style={{ marginBottom: "24px" }}>Pending Approval Requests</h2>
            <Button onClick={() => navigate("/")} style={{ marginBottom: "16px" }}>
                ← Back to Home
            </Button>
            {loading ? (
                <Spin />
            ) : (
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        pagination={false}
                    />
                    <div style={{ marginTop: "16px", textAlign: "right" }}>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            onChange={(page, pageSize) => fetchApprovals(page, pageSize)}
                            showSizeChanger={false}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default ApprovalsPage;
